var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanctionConfiguration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.806,
    height: 122.841,
    viewBox: "0 0 114.806 122.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11957",
    "data-name": "Path 11957",
    d: "M66.765,19.39a4.021,4.021,0,0,1,4.021-4.021h50.588a4.021,4.021,0,0,1,0,8.043H70.787a4.021,4.021,0,0,1-4.021-4.021Zm54.61,12.978H60.063a4.021,4.021,0,0,0,0,8.043h61.312a4.021,4.021,0,0,0,0-8.043Zm0,28.758H70.787a4.021,4.021,0,0,0,0,8.043h50.588a4.021,4.021,0,0,0,0-8.043Zm0,17H60.063a4.021,4.021,0,0,0,0,8.043h61.312a4.021,4.021,0,0,0,0-8.043ZM37.881,54.853H14.611a4.021,4.021,0,0,0-4.021,4.021v23.27a4.021,4.021,0,0,0,4.021,4.021h23.27A4.021,4.021,0,0,0,41.9,82.144V58.874A4.021,4.021,0,0,0,37.881,54.853Zm0-45.763H14.611a4.021,4.021,0,0,0-4.021,4.021v23.27A4.021,4.021,0,0,0,14.611,40.4h23.27A4.021,4.021,0,0,0,41.9,36.381V13.111A4.021,4.021,0,0,0,37.881,9.09Zm0,91.525H14.611a4.021,4.021,0,0,0-4.021,4.021v23.27a4.021,4.021,0,0,0,4.021,4.021h23.27a4.021,4.021,0,0,0,4.021-4.021v-23.27A4.021,4.021,0,0,0,37.881,100.615Zm83.493,6.268H70.787a4.021,4.021,0,1,0,0,8.043h50.588a4.021,4.021,0,1,0,0-8.043Zm0,17H60.063a4.021,4.021,0,1,0,0,8.043h61.312a4.021,4.021,0,1,0,0-8.043Z",
    transform: "translate(-10.59 -9.09)",
    fill: "#174a84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanctionConfiguration);
export default __webpack_public_path__ + "static/media/sanction-configuration.17b2b5d6c70874b8fe5891f97188869b.svg";
export { ForwardRef as ReactComponent };